
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { KnowledgeBaseEntry } from "@/types/theme";

export const useKnowledgeBaseQueries = (chatbotId: string | undefined) => {
  const { data: knowledgeBase, isLoading: isLoadingKnowledgeBase, error: knowledgeBaseError } = useQuery({
    queryKey: ["knowledge_base", chatbotId],
    queryFn: async () => {
      if (!chatbotId) return [];

      console.log("Fetching knowledge base for chatbot ID:", chatbotId);
      const { data, error } = await supabase
        .from("knowledge_base")
        .select("*")
        .eq("chatbot_id", chatbotId);

      if (error) {
        console.error("Error fetching knowledge base:", error);
        throw error;
      }
      
      console.log("Fetched knowledge base entries:", data?.length || 0);
      
      // Transform the data to match the KnowledgeBaseEntry type
      return (data || []).map((entry): KnowledgeBaseEntry => ({
        id: entry.id,
        chatbot_id: entry.chatbot_id,
        title: entry.title,
        content: entry.content,
        created_at: entry.created_at,
        updated_at: entry.updated_at
      }));
    },
    enabled: !!chatbotId,
  });

  return {
    knowledgeBase,
    isLoadingKnowledgeBase,
    error: knowledgeBaseError,
  };
};
